import { StyledTabBar } from "../../components/StyledTabBar/StyledTabBar";
import GeneralTab from "./components/GeneralTab";
import SecurityTab from "./components/SecurityTab";
import NotificationsTab from "./components/NotificationsTab";

export const SettingsPage = () => {
  return (
    <>
      <StyledTabBar
        size="md"
        tabList={[
          { value: "general", label: "General" },
          { value: "security", label: "Security" },
          { value: "notifications", label: "Notifications" },
        ]}
        tabPanels={[
          <GeneralTab key={1} />,
          <SecurityTab key={2} />,
          <NotificationsTab key={3} />,
        ]}
      />
    </>
  );
};
